import { EnvironmentConfig, LogLevel } from './environment-config';

export const environment: EnvironmentConfig = {
  enableAngularProdMode: true,
  enableOnboarding: true,
  apiUrl: 'https://timechef-dev.elior.com/api/v2',
  auth: {
    refreshTokenBeforeExpirationMinutes: 5,
  },
  env: 'development',
  cache: {
    defaultMinutes: 15,
  },
  universalAppUrl: 'https://timechef-dev.elior.com',
  urlScheme: 'timechef-dev://',
  googleTagManager: {
    isActive: true,
    id: 'GTM-NGVTBVP',
    auth: 'TzzZmKHQi_Fj8rIC4rmAPQ',
    preview: 'env-9',
    gaTrackingId: 'G-3E21NS7MST',
  },
  appInsights: {
    trackPageView: false,
    instrumentationKey: 'c77b7d79-eae5-41af-867c-d177e9c069e8',
  },
  logging: {
    console: {
      logLevel: LogLevel.Debug,
      isActive: true,
    },
    appInsights: {
      logLevel: LogLevel.Info,
      isActive: true,
    },
  },
};
